import {
  CollapsibleContainer,
  type VariantsProps,
} from '~/features/reservationInput/sd/CollapsibleContainer'
import {} from '~/styled-system/css'
import { CancelPolicyBody } from './CancelPolicyBody'

export { CancelPolicyFusuma } from './CancelPolicyFusuma'

export function CancelPolicy(variants: VariantsProps) {
  return (
    <CollapsibleContainer title="キャンセルポリシー" {...variants}>
      <CancelPolicyBody />
    </CollapsibleContainer>
  )
}
